"use client";

import { useMemo, type CSSProperties } from "react";
import { useMetadata } from "@/features/lomdaEditorV2/store";
import { useBrandKitFontFaces } from "@/features/brandKits/hooks/useBrandKitFontFaces";
import { useBuiltInFontsLoader } from "@/features/brandKits/hooks/useBuiltInFontsLoader";
import {
    FALLBACK_BODY_FONT,
    FALLBACK_TITLES_FONT,
} from "@/features/brandKits/lib/builtInFonts";

export function useBrandFonts(): CSSProperties {
    const metadata = useMetadata();
    useBuiltInFontsLoader();

    const brandStyle = metadata.style || {};
    const titlesFontFamily =
        brandStyle.titlesFontFamily || FALLBACK_TITLES_FONT;
    const bodyFontFamily = brandStyle.bodyFontFamily || FALLBACK_BODY_FONT;
    const customFonts = useMemo(
        () => brandStyle.customFonts ?? [],
        [brandStyle.customFonts]
    );
    const brandFonts = useMemo(
        () => [
            { family: titlesFontFamily, url: brandStyle.titlesFontUrl ?? null },
            { family: bodyFontFamily, url: brandStyle.bodyFontUrl ?? null },
            ...customFonts.map((f) => ({ family: f.family, url: f.url })),
        ],
        [
            titlesFontFamily,
            bodyFontFamily,
            brandStyle.titlesFontUrl,
            brandStyle.bodyFontUrl,
            customFonts,
        ]
    );

    useBrandKitFontFaces(brandFonts);

    return {
        "--font-titles": titlesFontFamily,
        "--font-body": bodyFontFamily,
    } as CSSProperties;
}
